import React from 'react';
import TicTacToeGame from './components/TicTacToeGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <TicTacToeGame />
    </div>
  );
}

export default App;